import "./style.css";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { hardResetProgress, useGameStore } from "./state/useGameStore";

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(<App />);

if (import.meta.env.DEV) {
  window.__heap = { store: useGameStore, hardResetProgress };
}
